// import React, { useState } from "react";
// import { ThreeDots } from "react-loader-spinner";
// import "../../Pages/Admin/Style.css";
// import "./update_categories.css";
// import { UpdateGiftCardApi } from "../../Api/apiUrls";

// function Update_gift_card({ giftCardId, name, email, remark, sold_at, mobileNumber, address, onClose }) {
//     const [newName, setNewName] = useState(name || "");
//     const [newEmail, setNewEmail] = useState(email || "");
//     const [newRemark, setNewRemark] = useState(remark || "");
//     const [newSoldAt, setNewSoldAt] = useState(sold_at >= 0 ? sold_at : "");
//     const [newMobileNumber, setNewMobileNumber] = useState(mobileNumber || "");
//     const [newAddress, setNewAddress] = useState(address || "");
//     const [isUpdating, setIsUpdating] = useState(false);
//     const [errors, setErrors] = useState({});

//     const validate = () => {
//         let tempErrors = {};
    
//         // Allow null or empty values, but if a value exists, it must be valid
//         tempErrors.name = newName === "" ? "" : newName ? "" : "Name is required";
//         tempErrors.email = newEmail === "" || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(newEmail) ? "" : "Valid email is required";
//         tempErrors.mobileNumber = newMobileNumber === "" || /^[0-9]{10}$/.test(newMobileNumber) ? "" : "Valid 10-digit mobile number is required";
//         tempErrors.address = newAddress === "" ? "" : newAddress ? "" : "Address is required";
//         tempErrors.soldAt = newSoldAt !== "" && newSoldAt >= 0 ? "" : "Sold At must be 0 or greater";
//         tempErrors.remark = newRemark === "" ? "" : newRemark ? "" : "Remark is required";
    
//         setErrors(tempErrors);
//         return Object.values(tempErrors).every(x => x === "");
//     };
    

//     const handleUpdate = () => {
//         if (!validate()) return;
//         setIsUpdating(true);
//         const formData = new FormData();
//         formData.append("gift_card_id", giftCardId);
//         formData.append("name", newName);
//         formData.append("email", newEmail);
//         formData.append("mobileNumber", newMobileNumber);
//         formData.append("address", newAddress);
//         formData.append("remark", newRemark);
//         formData.append("sold_at", newSoldAt);

//         fetch(UpdateGiftCardApi, {
//             method: "PUT",
//             body: formData,
//         })
//             .then((response) => response.json())
//             .then((data) => {
//                 if (data.success) {
//                     alert("Gift Card updated successfully!");
//                     onClose();
//                     window.location.reload();
//                 } else {
//                     alert("Error updating gift card");
//                 }
//                 setIsUpdating(false);
//             })
//             .catch((error) => {
//                 console.error("Error updating gift card:", error);
//                 setIsUpdating(false);
//             });
//     };

//     return (
//         <div className="popup-background">
//             <div className="popup">
//                 <div className="modal-content" style={{ width: "100%", padding: "2%", backgroundColor: "#fff", borderRadius: "5px" }}>
//                     <div className="modal-header" style={{ width: "100%", marginBottom: "3%", borderBottom: "solid 1px #7e7a7a8c" }}>
//                         <h5 className="modal-title" id="modalAddTitle" style={{ marginBottom: "2%" }}>
//                             <b>Update Gift Card</b>
//                         </h5>
//                         <button type="button" onClick={onClose} className="close" aria-label="Close">
//                             <span aria-hidden="true">&times;</span>
//                         </button>
//                     </div>

//                     <div className="modal-body" style={{ maxHeight: "400px", overflowY: "auto", padding: "2%" }}>
//                         <form>
//                             <div className="form-group">
//                                 <label className="small mb-1" htmlFor="name">Name</label>
//                                 <input className="form-control" id="name" type="text" value={newName} onChange={(e) => setNewName(e.target.value)} />
//                                 <small className="text-danger">{errors.name}</small>
//                             </div>
//                             <div className="form-group">
//                                 <label className="small mb-1" htmlFor="email">Email</label>
//                                 <input className="form-control" id="email" type="text" value={newEmail} onChange={(e) => setNewEmail(e.target.value)} />
//                                 <small className="text-danger">{errors.email}</small>
//                             </div>
//                             <div className="form-group">
//                                 <label className="small mb-1" htmlFor="mobileNumber">Mobile Number</label>
//                                 <input className="form-control" id="mobileNumber" type="text" value={newMobileNumber} onChange={(e) => setNewMobileNumber(e.target.value)} />
//                                 <small className="text-danger">{errors.mobileNumber}</small>
//                             </div>
//                             <div className="form-group">
//                                 <label className="small mb-1" htmlFor="address">Address</label>
//                                 <input className="form-control" id="address" type="text" value={newAddress} onChange={(e) => setNewAddress(e.target.value)} />
//                                 <small className="text-danger">{errors.address}</small>
//                             </div>
//                             <div className="form-group">
//                                 <label className="small mb-1" htmlFor="soldAt">Sold At</label>
//                                 <input className="form-control" id="soldAt" type="text" value={newSoldAt} onChange={(e) => setNewSoldAt(e.target.value)} />
//                                 <small className="text-danger">{errors.soldAt}</small>
//                             </div>
//                             <div className="form-group">
//                                 <label className="small mb-1" htmlFor="remark">Remark<font color="red">*</font></label>
//                                 <textarea style={{ height: "100px" }} className="form-control" id="remark" value={newRemark} onChange={(e) => setNewRemark(e.target.value)} />
//                                 <small className="text-danger">{errors.remark}</small>
//                             </div>
//                         </form>
//                     </div>

//                     <div className="modal-footer" style={{ padding: "2%", marginTop: "3%", borderTop: "solid 1px #7e7a7a8c" }}>
//                         <button
//                             type="button"
//                             className="btn btn-danger"
//                             onClick={onClose}
//                             style={{ display: window.innerWidth <= 780 ? 'none' : 'inline-block' }}
//                             >
//                             Close
//                             </button>


//                         {isUpdating ? (
//                             <ThreeDots color="#000" height={50} width={50} />
//                         ) : (
//                             <button type="button" className="btn btn-primary" onClick={handleUpdate} style={{ background: "#000", border: "none" }}>
//                                 Update
//                             </button>
//                         )}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// }

// export default Update_gift_card;


import React, { useState, useEffect } from "react";
import { ThreeDots } from "react-loader-spinner";
import "../../Pages/Admin/Style.css";
import "./update_categories.css";
import { API_URL, UpdateGiftCardApi } from "../../Api/apiUrls";
import Select from 'react-select';

function Update_gift_card({ 
  giftCardId, 
  name, 
  email, 
  remark, 
  sold_at, 
  mobileNumber, 
  address, 
  gst_number,
  onClose 
}) {
  const [newName, setNewName] = useState(name || "");
  const [newEmail, setNewEmail] = useState(email || "");
  const [newRemark, setNewRemark] = useState(remark || "");
  const [newSoldAt, setNewSoldAt] = useState(sold_at >= 0 ? sold_at : "");
  const [newMobileNumber, setNewMobileNumber] = useState(mobileNumber || "");
  const [newAddress, setNewAddress] = useState(address || "");
  const [newGstNumber, setNewGstNumber] = useState(gst_number || "");
  const [isUpdating, setIsUpdating] = useState(false);
  const [errors, setErrors] = useState({});
  
  // New state for appointment booking
  const [bookAppointment, setBookAppointment] = useState(false);
  const [instructors, setInstructors] = useState([]);
  const [workshops, setWorkshops] = useState([]);
  const [slots, setSlots] = useState([]);
  const [selectedInstructor, setSelectedInstructor] = useState(null);
  const [selectedWorkshop, setSelectedWorkshop] = useState(null);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [isLoading, setIsLoading] = useState({
    instructors: false,
    workshops: false,
    slots: false
  });

  // Fetch instructors on component mount
  useEffect(() => {
    if (bookAppointment) {
      setIsLoading(prev => ({...prev, instructors: true}));
      fetch(`${API_URL}/pass_schedule/get-instructors_of_schedules/`)
        .then(response => response.json())
        .then(data => {
          const options = data.data.users.map(user => ({
            value: user.id,
            label: user.name,
            image: `${API_URL}/${user.profile_image}`
          }));
          setInstructors(options);
        })
        .finally(() => setIsLoading(prev => ({...prev, instructors: false})));
    }
  }, [bookAppointment]);

  // Fetch workshops when instructor is selected
  useEffect(() => {
    if (selectedInstructor) {
      setIsLoading(prev => ({...prev, workshops: true}));
      fetch(`${API_URL}/pass_schedule/get-workshop_by_instructor_id_of_schedules/?workshop_instructor_id=${selectedInstructor.value}`)
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            const options = data.data.Workshop.map(workshop => ({
              value: workshop.id,
              label: workshop.name
            }));
            setWorkshops(options);
          }
        })
        .finally(() => setIsLoading(prev => ({...prev, workshops: false})));
    }
  }, [selectedInstructor]);

  // Fetch slots when workshop is selected
  useEffect(() => {
    if (selectedWorkshop) {
      setIsLoading(prev => ({...prev, slots: true}));
      fetch(`${API_URL}/pass_schedule/get-workshop_by_slot_id_of_schedules/?workshop_slot_id=${selectedWorkshop.value}`)
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            const options = data.data.WorkshopSlot.map(slot => {
                      const formattedDate = new Date(slot.date).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                      });
                      const startTime = new Date(`1970-01-01T${slot.startTime}`).toLocaleTimeString('en-US', {
                        hour: 'numeric',
                        minute: '2-digit',
                      });
                      const endTime = new Date(`1970-01-01T${slot.endTime}`).toLocaleTimeString('en-US', {
                        hour: 'numeric',
                        minute: '2-digit',
                      });
                      return {
                        value: slot.id,
                        label: `${formattedDate} | ${startTime} - ${endTime}`,
                      };
            });
            setSlots(options);
          }
        })
        .finally(() => setIsLoading(prev => ({...prev, slots: false})));
    }
  }, [selectedWorkshop]);

  const getGstBreakdown = (amount) => {
    const numericAmount = Number(amount);
    if (!Number.isFinite(numericAmount) || numericAmount < 0) {
      return {
        baseAmount: 0,
        cgstAmount: 0,
        sgstAmount: 0,
        gstAmount: 0,
        totalAmount: 0,
      };
    }

    const baseAmount = Number(numericAmount.toFixed(2));
    const cgstAmount = Number((numericAmount * 0.09).toFixed(2));
    const sgstAmount = Number((numericAmount * 0.09).toFixed(2));
    const gstAmount = Number((numericAmount * 0.18).toFixed(2));
    const totalAmount = Number((baseAmount + gstAmount).toFixed(2));

    return { baseAmount, cgstAmount, sgstAmount, gstAmount, totalAmount };
  };

  const validate = () => {
    let tempErrors = {};
    const trimmedGstNumber = newGstNumber.trim().toUpperCase();
    const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
  
    // Original validation
    tempErrors.name = newName === "" ? "" : newName ? "" : "Name is required";
    tempErrors.email = newEmail === "" || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(newEmail) ? "" : "Valid email is required";
    tempErrors.mobileNumber = newMobileNumber === "" || /^[0-9]{10}$/.test(newMobileNumber) ? "" : "Valid 10-digit mobile number is required";
    tempErrors.address = newAddress === "" ? "" : newAddress ? "" : "Address is required";
    tempErrors.soldAt = newSoldAt !== "" && newSoldAt >= 0 ? "" : "Sold At must be 0 or greater";
    tempErrors.remark = newRemark === "" ? "" : newRemark ? "" : "Remark is required";
    tempErrors.gstNumber = trimmedGstNumber === "" || gstRegex.test(trimmedGstNumber) ? "" : "Valid GST number is required";
    
    // Appointment validation if booking is selected
    if (bookAppointment) {
      tempErrors.instructor = selectedInstructor ? "" : "Instructor is required";
      tempErrors.workshop = selectedWorkshop ? "" : "Workshop is required";
      tempErrors.slot = selectedSlot ? "" : "Slot is required";
    }

    setErrors(tempErrors);
    return Object.values(tempErrors).every(x => x === "");
  };

  const handleUpdate = () => {
    if (!validate()) return;
    
    setIsUpdating(true);
    const formData = new FormData();
    const trimmedGstNumber = newGstNumber.trim().toUpperCase();

    formData.append("gift_card_id", giftCardId);
    formData.append("name", newName);
    formData.append("email", newEmail);
    formData.append("mobileNumber", newMobileNumber);
    formData.append("address", newAddress);
    formData.append("remark", newRemark);
    formData.append("sold_at", newSoldAt);

    if (trimmedGstNumber) {
      formData.append("gst_number", trimmedGstNumber);
    }

    // Add appointment data if booking was selected
    if (bookAppointment && selectedSlot) {
      formData.append("appointment_slot_id", selectedSlot.value);
    }

    fetch(UpdateGiftCardApi, {
      method: "PUT",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          alert("Gift Card updated successfully!");
          onClose();
          // window.location.reload();
        } else {
          alert("Error updating gift card");
        }
      })
      .catch((error) => {
        console.error("Error updating gift card:", error);
      })
      .finally(() => {
        setIsUpdating(false);
      });
  };

  return (
    <div className="popup-background">
      <div className="popup">
        <div className="modal-content" style={{ width: "100%", padding: "2%", backgroundColor: "#fff", borderRadius: "5px" }}>
          <div className="modal-header" style={{ width: "100%", marginBottom: "3%", borderBottom: "solid 1px #7e7a7a8c" }}>
            <h5 className="modal-title" id="modalAddTitle" style={{ marginBottom: "2%" }}>
              <b>Update Gift Card</b>
            </h5>
            <button type="button" onClick={onClose} className="close" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div className="modal-body" style={{ maxHeight: "400px", overflowY: "auto", padding: "2%" }}>
            <form>
              {/* Original form fields */}
              <div className="form-group">
                <label className="small mb-1" htmlFor="name">Name</label>
                <input className="form-control" id="name" type="text" value={newName} onChange={(e) => setNewName(e.target.value)} />
                <small className="text-danger">{errors.name}</small>
              </div>
              <div className="form-group">
                <label className="small mb-1" htmlFor="email">Email</label>
                <input className="form-control" id="email" type="text" value={newEmail} onChange={(e) => setNewEmail(e.target.value)} />
                <small className="text-danger">{errors.email}</small>
              </div>
              <div className="form-group">
                <label className="small mb-1" htmlFor="mobileNumber">Mobile Number</label>
                <input className="form-control" id="mobileNumber" type="text" value={newMobileNumber} onChange={(e) => setNewMobileNumber(e.target.value)} />
                <small className="text-danger">{errors.mobileNumber}</small>
              </div>
              <div className="form-group">
                <label className="small mb-1" htmlFor="address">Address</label>
                <input className="form-control" id="address" type="text" value={newAddress} onChange={(e) => setNewAddress(e.target.value)} />
                <small className="text-danger">{errors.address}</small>
              </div>
              <div className="form-group">
                <label className="small mb-1" htmlFor="soldAt">Sold At</label>
                <input className="form-control" id="soldAt" type="text" value={newSoldAt} onChange={(e) => setNewSoldAt(e.target.value)} />
                <small className="text-muted d-block mt-1">This is without GST amount</small>

                <div className="gst-breakdown mt-2">
                  <div className="gst-row">
                    <div className="gst-label">Amount (without GST)</div>
                    <div className="gst-value">Rs. {getGstBreakdown(newSoldAt).baseAmount.toFixed(2)}</div>
                  </div>
                  <div className="gst-row gst-muted">
                    <div className="gst-label">CGST 9%</div>
                    <div className="gst-value">Rs. {getGstBreakdown(newSoldAt).cgstAmount.toFixed(2)}/-</div>
                  </div>
                  <div className="gst-row gst-muted">
                    <div className="gst-label">SGST 9%</div>
                    <div className="gst-value">Rs. {getGstBreakdown(newSoldAt).sgstAmount.toFixed(2)}/-</div>
                  </div>
                  <div className="gst-row gst-total">
                    <div className="gst-label">GST 18%</div>
                    <div className="gst-value">Rs. {getGstBreakdown(newSoldAt).gstAmount.toFixed(2)}/-</div>
                  </div>
                  <div className="gst-row gst-total gst-grand-total">
                    <div className="gst-label">Total with GST</div>
                    <div className="gst-value">Rs. {getGstBreakdown(newSoldAt).totalAmount.toFixed(2)}/-</div>
                  </div>
                </div>

                <small className="text-danger">{errors.soldAt}</small>
              </div>
              <div className="form-group">
                <label className="small mb-1" htmlFor="gstNumber">GST Number <small className="text-muted">(optional)</small></label>
                <input
                  className="form-control"
                  id="gstNumber"
                  type="text"
                  value={newGstNumber}
                  onChange={(e) => setNewGstNumber(e.target.value)}
                  placeholder="Enter GST number"
                />
                <small className="text-danger">{errors.gstNumber}</small>
              </div>
              <div className="form-group">
                <label className="small mb-1" htmlFor="remark">Remark<font color="red">*</font></label>
                <textarea style={{ height: "100px" }} className="form-control" id="remark" value={newRemark} onChange={(e) => setNewRemark(e.target.value)} />
                <small className="text-danger">{errors.remark}</small>
              </div>

              {/* Appointment booking section */}
              <div className="form-group">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="bookAppointment"
                    checked={bookAppointment}
                    onChange={(e) => setBookAppointment(e.target.checked)}
                  />
                  <label className="form-check-label" htmlFor="bookAppointment">
                    Book Appointment with this Gift Card
                  </label>
                </div>
              </div>

              {bookAppointment && (
                <>
                  <div className="form-group">
                    <label className="small mb-1">Instructor</label>
                    <Select
                      options={instructors}
                      value={selectedInstructor}
                      onChange={setSelectedInstructor}
                      isLoading={isLoading.instructors}
                      placeholder="Select instructor"
                    />
                    <small className="text-danger">{errors.instructor}</small>
                  </div>

                  <div className="form-group">
                    <label className="small mb-1">Workshop</label>
                    <Select
                      options={workshops}
                      value={selectedWorkshop}
                      onChange={setSelectedWorkshop}
                      isLoading={isLoading.workshops}
                      isDisabled={!selectedInstructor}
                      placeholder={selectedInstructor ? "Select workshop" : "Select instructor first"}
                    />
                    <small className="text-danger">{errors.workshop}</small>
                  </div>

                  <div className="form-group">
                    <label className="small mb-1">Available Slots</label>
                    <Select
                      options={slots}
                      value={selectedSlot}
                      onChange={setSelectedSlot}
                      isLoading={isLoading.slots}
                      isDisabled={!selectedWorkshop}
                      placeholder={selectedWorkshop ? "Select slot" : "Select workshop first"}
                    />
                    <small className="text-danger">{errors.slot}</small>
                  </div>
                </>
              )}
            </form>
          </div>

          <div className="modal-footer" style={{ padding: "2%", marginTop: "3%", borderTop: "solid 1px #7e7a7a8c" }}>
            <button
              type="button"
              className="btn btn-danger"
              onClick={onClose}
              style={{ display: window.innerWidth <= 780 ? 'none' : 'inline-block' }}
            >
              Close
            </button>

            {isUpdating ? (
              <ThreeDots color="#000" height={50} width={50} />
            ) : (
              <button type="button" className="btn btn-primary" onClick={handleUpdate} style={{ background: "#000", border: "none" }}>
                Update
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Update_gift_card;

